import { CommonModule } from '@angular/common';
import { NgModule, Component, ChangeDetectionStrategy, HostBinding, ViewEncapsulation, Input } from '@angular/core';
import { BaseDirective } from '../../base.directive';

import { EuiOverlayHeaderComponent } from './components/eui-overlay-header/eui-overlay-header.component';
import { EuiOverlayBodyComponent } from './components/eui-overlay-body/eui-overlay-body.component';
import { EuiOverlayFooterComponent } from './components/eui-overlay-footer/eui-overlay-footer.component';

@Component({
    selector: 'eui-overlay',
    templateUrl: './eui-overlay.component.html',
    styleUrls: ['./styles/_index.scss'],
    changeDetection: ChangeDetectionStrategy.Default,
    encapsulation: ViewEncapsulation.None,
})
export class EuiOverlayComponent extends BaseDirective {

    @HostBinding('class')
    get cssClasses() {
        return [
            super.getCssClasses(`eui-overlay`),
            this.isActive ? 'eui-overlay--is-active' : '',
            this.position ? 'eui-overlay-offset eui-overlay-offset--position-' + this.position : '',
            this.width ? 'eui-overlay-offset eui-overlay-offset--width-' + this.width : '',
        ].join(' ').trim();
    }

    @Input() isActive = false;
    @Input() position = 'right';
    @Input() width = '25';

    constructor (
    ) {
        super();
    }
}

/* ***************************************** */
/* MODULE EXPORT */
/* ***************************************** */
@NgModule({
    imports: [
        CommonModule,
    ],
    declarations: [
        EuiOverlayHeaderComponent,
        EuiOverlayBodyComponent,
        EuiOverlayFooterComponent,
        EuiOverlayComponent,
    ],
    exports: [
        EuiOverlayHeaderComponent,
        EuiOverlayBodyComponent,
        EuiOverlayFooterComponent,
        EuiOverlayComponent,
    ],
})
export class EuiOverlayModule { }
